<template>
  <div class="sm:w-1/2 p-2 flex flex-col text-sm leading-tight">
    <div class="font-medium">
      <slot></slot>
    </div>
    <div class="mt-2">
      <m-radio
        :id="id"
        :modelValue="value.value"
        @change="handleInputChange($event, 'value')"
        :options="[...options, 'other']"
      />
      <m-textarea
        v-if="value.value === 'other'"
        :modelValue="value.other"
        @change="handleInputChange($event, 'other')"
        class="ml-6 mt-2"
      ></m-textarea>
      <p
        v-if="validationError"
        class="text-red-600 text-sm"
      >{{ validationError }}</p>
    </div>
  </div>
</template>

<script>


export default {
  name: 'question',
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    validationError: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleInputChange(val, type) {
      const changedValues = {
        ...this.value,
        [type]: val,
      };

      if (type === 'value' && val !== 'other') {
        changedValues.other = '';
      }

      this.$emit('input', changedValues);
    },
  },
};
</script>
